<template>
  <div class="list">
    <div class="back" @click="back">
      <img src="@/assets/back.png" alt="返回" />
      返回
    </div>
    <div class="list_label">
      {{ authType == "UKEY" ? "Ukey授权记录" : "电照授权记录" }}
    </div>
    <div class="list_info">
      当前单位： {{ certInfo.corporateName }}
      <div style="display: inline-block; width: 40px"></div>
      <span v-if="authType == 'UKEY'">法人一证通序列号：{{ certInfo.sn }}</span>
      <span v-else>统一社会信用代码：{{ certInfo.creditCode }}</span>
      <!-- 证书序列号：{{ authType== 'UKEY' ? certInfo.sn:  certInfo.creditCode}} -->
    </div>
    <el-divider></el-divider>
    <el-form class="search_form" :model="searchForm" :inline="true" ref="searchFrom">
      <el-form-item label="被授权人姓名" prop="userName">
        <el-input v-model="searchForm.userName" clearable style="width: 190px" placeholder="请输入姓名查找"></el-input>
      </el-form-item>
      <el-form-item label="授权时间" prop="startDate">
        <el-select v-model="searchForm.startDate" style="width: 190px">
          <el-option value="0" label="全部">全部</el-option>
          <el-option value="1" label="最近一月">最近一月</el-option>
          <el-option value="3" label="最近三个月">最近三个月</el-option>
          <el-option value="6" label="最近半年">最近半年</el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="申领状态">
        <el-select v-model="searchForm.time" style="width: 140px">
          <el-option>一周</el-option>
          <el-option>一月</el-option>
          <el-option>三月</el-option>
          <el-option>半年</el-option>
          <el-option>一年</el-option>
          <el-option>全部</el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item class="btn-group">
        <el-button type="primary" @click="handleCurrentChange(1)">查找</el-button>
        <el-button @click="reset">重置</el-button>
        <el-button type="danger" @click="handleCancel" v-if="authType == 'UKEY'">取消授权</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" v-loading="loading" @selection-change="handleSelectionChange" tooltip-effect="dark"
      ref="multipleTable" width="100">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="userName" label="被授权人姓名" w></el-table-column>
      <el-table-column prop="userIdcard" label="被授权人身份证号">
        <template slot-scope="scope">
          <!-- {{ scope.row.userIdcard | filterIdCard }}
          <i class="el-icon-view" @click="userIdcard=!row.userIdcard"></i> -->
          <span>{{ scope.row.showInfo == 1 ? scope.row.userIdcard.replace(/^(\w{3})\w{11,}(\w{4})$/,
            "\$1********\$2") : scope.row.userIdcard }}</span>&nbsp;
          <i class="el-icon-view" @click="showId(scope)"></i>
        </template>
      </el-table-column>
      <el-table-column prop="userMobile" label="被授权人手机号">
        <template slot-scope="scope">
          <!-- {{ scope.row.userMobile | filterMobile }} -->
          <!-- <i class="el-icon-view" @click="userIdcard=!row.userIdcard"></i> -->
          <span>{{ scope.row.showMobile == 1 ? scope.row.userMobile.replace(/^(\d{3})\d*(\d{4})$/,
            "\$1****\$2") : scope.row.userMobile }}</span>&nbsp;
          <i class="el-icon-view" @click="showMobiles(scope)"></i>
        </template>
      </el-table-column>
      <el-table-column prop="roleName" label="被授权角色"></el-table-column>
      <el-table-column prop="grantTime" label="授权时间"></el-table-column>
      <!-- <el-table-column prop="grantTime" label="申领状态"></el-table-column> -->
    </el-table>
    <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="current" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
      layout="total, prev, pager, next, sizes, jumper" :total="total">
    </el-pagination>
    <InputPin ref="inputPin" @submit="submit" />
  </div>
</template>

<script>
import { GetGrantList, getDZGrantList, CancelCert, GetRandom } from "@/api";
import PinError from "./Dialog/pin-error.vue";
import InputPin from "./Dialog/input-pin.vue";
export default {
  components: {
    PinError,
    InputPin,
  },
  // 数据脱敏·
  // filters: {
  //   filterIdCard(val) {
  //     val = val + "";
  //     return val.replace(/(\w{3})\w{11,}(\w{4})/, "$1***********$2");
  //   },
  //   // 手机号脱敏
  //   filterMobile(val) {
  //     val = val + "";
  //     return val.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
  //   }
  // },
  data() {
    return {
      loading: false,
      certInfo: {},
      searchForm: {
        userName: "",
        startDate: "0",
      },
      list: [],
      total: 0,
      pageSize: 10,
      current: 1,
      multipleSelection: [],
      // showIdCard:true,
      // showMobile:true
    };
  },
  created() {
    this.certInfo = this.$store.state.certInfo;
    this.getGrantList();
  },
  computed: {
    authType() {
      return this.$store.state.authType;
    },
  },
  methods: {
    // 显示身份证Id
    showId(scope) {
      // console.log(scope.row.showInfo, '123')
      scope.row.showInfo = !scope.row.showInfo
    },
    // 显示手机号
    showMobiles(scope) {
      scope.row.showMobile = !scope.row.showMobile
    },
    async handleCancel() {
      if (this.multipleSelection.length) {
        this.$refs.inputPin.show();
      }
    },
    async submit(pwd) {
      try {
        this.loading = true;
        let params = {
          pwd, //PIN码
          devParam: this.certInfo.devParam, //ukey对应参数
          devType: this.certInfo.devType, //ukey对应参数
          asymid: 2, //验证RSA或者SM2
        };
        let { data } = await this.$ukJsBridge.verifyUserPin(params);
        console.log(data, "data");
        if (data.ret == 0) {
          let { key, rnd } = await GetRandom();
          console.log(key, rnd);
          // 对rnd签名
          let signParams = {
            data: rnd, // 待签名的数据，string 类型
            pwd, // usb-key pin 码
            devParam: this.certInfo.devParam, //ukey对应参数
            devType: this.certInfo.devType, //ukey对应参数
            asymid: 2, //验证RSA或者SM2
          };
          let { data: signResult } = await this.$ukJsBridge.sign(signParams);
          console.log(signResult);
          if (signResult.ret != 0) {
            throw new Error(this.$codeToStr(signResult.ret));
          } else {
            const signature = signResult.str;
            let submitParams = {
              signature,
              cert: this.certInfo.cert,
              sigAlg: "SM2",
              rndKey: key,
              grantIds: this.multipleSelection.map((item) => item.grantId),
            };
            //  撤销授权
            await CancelCert(submitParams);
            //  重新请求列表
            await this.getGrantList();
          }
        } else {
          let lockUkeyCode = [-2113666988, -2113601478, -4127195099];
          if (lockUkeyCode.includes(data.ret)) {
            // this.pinErrorDialog = true;
            this.$refs.pinError.show();
          } else {
            this.$message.warning(this.$codeToStr(data.ret));
          }
        }
      } catch (error) {
        // this.$message.warning(error.message);
        this.$alert(error.message, "提示");
      } finally {
        this.loading = false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    back() {
      this.$router.go(-1);
    },
    reset() {
      this.$refs.searchFrom.resetFields();
    },
    handleCurrentChange(current) {
      this.current = current;
      this.getGrantList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getGrantList();
    },
    async getGrantList() {
      try {
        this.loading = true;
        let startDate = new Date();
        let pastMonth =
          startDate.getMonth() - parseInt(this.searchForm.startDate);
        startDate.setMonth(pastMonth);
        startDate = this.searchForm.startDate == "0" ? "" : startDate;
        let params = {
          certSn: this.certInfo.sn,
          startDate,
          userName: this.searchForm.userName,
          pageNum: this.current,
          pageSize: this.pageSize,
          creditCode: this.certInfo.creditCode,
        };
        let result = {};
        if (this.authType == "UKEY") {
          result = await GetGrantList(params);
        } else {
          result = await getDZGrantList(params);
        }
        let { records: list, total } = result;
        this.total = total;

        this.list = list.map((item) => {
          item.showInfo = '1'
          item.showMobile = '1'
          return item
        })
        console.log(list, '!!!')
      } catch (error) {
        console.log(error);
        // this.$message.warning(error.message)
        this.$alert(error.message, "提示");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  padding: 0 20px;
  width: 900px;
  box-sizing: border-box;
  margin: 0 auto;

  .back {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 20px;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #595959;
    line-height: 21px;
    cursor: pointer;

    img {
      width: 12px;
      height: 20px;
    }
  }

  &_label {
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    margin: 14px 0;
  }

  &_info {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6a6c7d;
    text-align: left;
  }

  .search_form {
    display: flex;
    justify-content: space-between;
  }

  .btn-group {
    .submit {
      width: 48px;
      height: 32px;
      line-height: 32px;
      background: #3340ca;
      color: #fff;
    }

    .reset {
      width: 48px;
      height: 32px;
      line-height: 32px;
      color: #595959;
    }
  }

  .pagination {
    margin: 19px 0;
    text-align: right;
  }

  ::v-deep .el-divider--horizontal {
    margin: 14px 0;
  }

  //   /deep/ .el-button--primary{
  //       background: #3340CA !important;
  //       border-color: #3340CA !important;
  //   }
  //   /deep/ .el-table th.el-table__cell{
  //       background-color: #F6F6F9;
  //   }
  ::v-deep .el-form--inline .el-form-item {
    margin-right: 0;
  }

  ::v-deep .el-pagination__jump {
    margin-left: 0;
  }

  //   /deep/.el-select .el-input.is-focus .el-input__inner{
  //     border-color: #3e4ace !important;
  //   }
}
</style>
